const sm = "576px";
const md = "768px";
const lg = "992px";
const xl = "1200px";
const xxl = "1400px";

export const viewPortBreakpoints = {
  sm,
  md,
  lg,
  xl,
  xxl,
};
